import { ApiService } from "./ApiService"

export class LogisticItemService {

    static uri = '/logistic/items';
    static uriMonitoring = '/logistic/monitoring';

    // Khusus untuk halaman "Monitoring Barang" (mengembalikan stats + data paginasi)
    static getMonitoring({ params }) {
        return ApiService.get(`${this.uriMonitoring}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    // Untuk keperluan Select/Dropdown
    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static show({ id }) {
        return ApiService.get(`${this.uriMonitoring}/show/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static store({ data }) {
        return ApiService.post(`${this.uriMonitoring}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static update({ id, data }) {
        return ApiService.put(`${this.uri}/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static destroy({ id }) {
        return ApiService.delete(`${this.uri}/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}